import React from "react";

const Title = () => {
  return <>Promo Prefixes</>;
};

export default Title;
